import React from 'react';

import { MoreHorizOutlined } from '@mui/icons-material';
import { IconButton, Menu, Tooltip } from '@mui/material';

import ArchiveWorkflowButton from './ArchiveWorkflowButton';

export default function WorkflowContextActionsMenu() {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    event.preventDefault();
    setAnchorEl(event.currentTarget);
  };
  const open = Boolean(anchorEl);

  return (
    <>
      <Tooltip title="Additional actions">
        <span>
          <IconButton type="button" size="small" onClick={handleClick} color="inherit">
            <MoreHorizOutlined fontSize="small" />
          </IconButton>
        </span>
      </Tooltip>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        <ArchiveWorkflowButton onClose={handleClose} />
      </Menu>
    </>
  );
}
